module.exports = __webpack_public_path__ + "static/img/rc.a518554.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rc.jpg
// module id = m8JV
// module chunks = 7 8